import { useContext, useEffect, useState } from "react";

import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import LittleNotify from "../../UI/Notification/LittleNotify/LittleNotify";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";


const AddMasPage = () => {

  const { addNewMas, addNewMasPost } = useContext(AdminContext);
  const [success, setSuccess] = useState(null);
  const [regions, setRegions] = useState(null);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    patronymic: "",
    regId: null,
  });

  const closeSuccess = () => {
    setSuccess(null);
  };

  const formChangeHanlder = (el) => {
    const { name, value } = el.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const submithandler = (e) => {
    e.preventDefault();
    
    if(formData.name.length > 2 && formData.surname.length >= 2 && formData.patronymic.length > 2 && formData.regId)
    { 
      addNewMasPost(formData).then(res => {
        if(res.status === 200)
        {
          setSuccess(res.data)
          setFormData((prev) => {
            return {
              name: "",
              surname: "",
              patronymic: "",
              regId: prev.regId,
            }
          })
        } else 
        {
     
          setError(res.response.data)
        }
      })
    }
  }
 
  useEffect(() => {
    document.title = 'Добавить МАСа'
    addNewMas().then((res) => {
      if (res.status === 200) {
        setFormData((prev) => {
          return { ...prev, regId: res.data[0].id }
        });
        setRegions(res.data);
      } 
      
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="login">
      <div className="container">
        <div className="admin__user">

          <ButtonBack/>
        </div>
        <h1 className="login__text">Создать МАС'а</h1>

        <div
          className="login__wrapper"
          style={{ position: "relative", minHeight: 580 }}
        >
          {!regions ? (
            <CoveredBackground>
              <Loader />
            </CoveredBackground>
          ) : (
            <>

          {error && <p
                style={{ textAlign: "center", color: "crimson", fontSize: 30 }}
              >
                {error}
              </p>}
              

              <form className="login__form" onSubmit={submithandler}>
                <div className="login__item">
                  <label htmlFor="name">Имя:</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    className="login__input"
                    placeholder="Имя"
                    autoComplete="off"
                    required
                    onInput={formChangeHanlder}
                  />
                </div>
                <div className="login__item">
                  <label htmlFor="surname">Фамилия:</label>
                  <input
                    type="text"
                    id="surname"
                    name="surname"
                    value={formData.surname}
                    className="login__input"
                    placeholder="Фамилия"
                    autoComplete="off"
                    required
                    onInput={formChangeHanlder}
                  />
                </div>

                <div className="login__item">
                  <label htmlFor="patronymic">Отчество:</label>
                  <input
                    type="text"
                    id="patronymic"
                    name="patronymic"
                    value={formData.patronymic}
                    className="login__input"
                    placeholder="Отчество"
                    autoComplete="off"
                    required
                    onInput={formChangeHanlder}
                  />
                </div>

                <div className="login__item">
                  <label htmlFor="regId">Регион:</label>
                  <select
                    id="regId"
                    name="regId"
                    className="login__input"
                    required
                    onChange={formChangeHanlder}
                  > 
                    {regions.map((reg) => (
                      <option value={reg.id} key={reg.id}>
                        {reg.name}
                      </option>
                    ))}
                  </select>
                </div> 

                <button
                  className="login__wrapper__link"
                  style={{ fontSize: 29 }}
                >
                  Сохранить
                </button>
              </form>
            </>
          )}
        </div>
      </div>
      {success && <LittleNotify title={success} close={closeSuccess} />}
    </section>
  );
};

export default AddMasPage;
